module.exports = "<i class=\"ion-home\"\n   ng-if=\"$ctrl.storageActive != null\"\n   ng-class=\"{'storage-icon-active' : $ctrl.storageActive}\">\n</i>\n\n<span ng-if=\"::$ctrl.withLabel && $ctrl.storageActive\" translate>\n    STORAGE_ACTIVE\n</span>\n\n<span ng-if=\"::$ctrl.withLabel && !$ctrl.storageActive\" translate>\n    STORAGE_NOT_ACTIVE\n</span>\n";


//////////////////
// WEBPACK FOOTER
// ./src/modules/main/components/wheel-storage-active-icon/wheel-storage-active-icon.html
// module id = 892
// module chunks = 0